import GeneralSettings from '~/models/GeneralSettings';

/**
 * class representing logo settings section data
 * @extends GeneralSettings
 * @author fz
 */
export default class Logo extends GeneralSettings {
    static _url = `${GeneralSettings._url}logo/`;

    constructor(id = null, options) {
        super(id, options);
    }

    static getLogo(logoType) {
        const requestUrl = `${this._url}get/${logoType}/`;
        return this.api.get(requestUrl);
    }

    static saveLogo(params) {
        const requestUrl = `${this._url}save/`;
        const requestPayload = params ?? {};
        return this.api.post(requestUrl, requestPayload);
    }

    static deleteLogo(params) {
        const requestUrl = `${this._url}delete/`;
        const requestPayload = { data: params ?? {} };
        return this.api.delete(requestUrl, requestPayload);
    }
}
